import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2019 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useContext, useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions } from '@mui/material';
import { ButtonWithProgress } from '../../components/button-with-progress';
import { ExtensionRatingStarSetter } from './extension-rating-star-setter';
import { MainContext } from '../../context';
import { usePostReview } from './use-extension-reviews';
const REVIEW_COMMENT_SIZE = 2048;
export const ExtensionReviewDialog = props => {
    const [open, setOpen] = useState(false);
    const [rating, setRating] = useState(1);
    const [comment, setComment] = useState('');
    const [commentError, setCommentError] = useState();
    const context = useContext(MainContext);
    const { mutate: postReview, isPending: posting } = usePostReview(props.extension);
    const handleOpenButton = () => {
        if (context.user) {
            setOpen(true);
        }
    };
    const handleCancel = () => setOpen(false);
    const handlePost = () => postReview({ review: { rating, comment }, postUrl: props.reviewPostUrl }, {
        onSuccess: () => {
            setOpen(false);
            setComment('');
        }
    });
    const handleCommentChange = (event) => {
        const comment = event.target.value;
        let commentError;
        if (comment.length > REVIEW_COMMENT_SIZE) {
            commentError = `The review comment must not be longer than ${REVIEW_COMMENT_SIZE} characters.`;
        }
        setComment(comment);
        setCommentError(commentError);
    };
    if (!context.user) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [!posting && (_jsx(Button, { variant: 'contained', color: 'secondary', onClick: handleOpenButton, children: "Write a Review" })), _jsxs(Dialog, { open: open, onClose: handleCancel, children: [_jsxs(DialogTitle, { children: [props.extension.displayName ?? props.extension.name, " Review"] }), _jsxs(DialogContent, { children: [_jsxs(DialogContentText, { children: ["Your review will be posted publicly as ", context.user.loginName] }), _jsx(Box, { component: 'div', sx: {
                                    width: { xs: '140%', sm: '100%', md: '100%', lg: '100%', xl: '100%' },
                                    transform: {
                                        xs: 'scale(.7) translateX(-23%)',
                                        sm: 'none',
                                        md: 'none',
                                        lg: 'none',
                                        xl: 'none'
                                    }
                                }, children: _jsx(ExtensionRatingStarSetter, { handleRatingChange: (rating) => setRating(rating) }) }), _jsx(TextField, { margin: 'dense', label: 'Your Review...', fullWidth: true, multiline: true, variant: 'outlined', rows: 4, error: Boolean(commentError), helperText: commentError, onChange: handleCommentChange })] }), _jsxs(DialogActions, { sx: { justifyContent: { xs: 'center', sm: 'end', md: 'end', lg: 'end', xl: 'end' } }, children: [_jsx(Button, { onClick: handleCancel, color: 'secondary', children: "Cancel" }), _jsx(ButtonWithProgress, { autoFocus: true, error: Boolean(commentError), working: posting, sx: { ml: 1 }, onClick: handlePost, children: "Post Review" })] })] })] }));
};
//# sourceMappingURL=extension-review-dialog.js.map